// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1zcEh","notes":"Notes_notes__GDrSu","note":"Notes_note__2-_KI","markdown":"Notes_markdown__1mm8N"};